import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import {
  LucideAngularModule,
  Activity,
  ArrowDown,
  ArrowUp,
  CheckCircle,
  CircleAlert,
  CircleCheck,
  CircleX,
  Cloud,
  Copy,
  CreditCard,
  Ellipsis,
  Eye,
  FileText,
  Github,
  Hash,
  Key,
  LayoutDashboard,
  Layers,
  List,
  ListTodo,
  MessageSquare,
  Loader,
  LogOut,
  RefreshCw,
  RotateCcw,
  ScrollText,
  Search,
  Settings,
  Settings2,
  Shield,
  Trash2,
  TriangleAlert,
  UserCheck,
  UserX,
  Users,
  X,
  Zap,
  Bug,
  ChevronDown,
  ChevronRight,
  Table2,
  GitMerge,
  Cpu,
  ScanSearch,
} from 'lucide-angular';

import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { OverviewComponent } from './features/overview/overview.component';
import { UserManagementComponent } from './features/users/user-management.component';
import { SubscriptionManagementComponent } from './features/subscriptions/subscription-management.component';
import { OrgContextSidebarComponent } from './features/subscriptions/org-context-sidebar.component';
import { IntegrationControlComponent } from './features/integrations/integration-control.component';
import { SystemLogsComponent } from './features/logs/system-logs.component';
import { BugReportsComponent } from './features/bug-reports/bug-reports.component';
import { AdminSettingsComponent } from './features/settings/admin-settings.component';
import { LoginComponent } from './auth/login/login.component';
import { ForbiddenComponent } from './features/forbidden/forbidden.component';
import { MonitoringOverviewComponent } from './features/monitoring/monitoring-overview.component';
import { TierManagementComponent } from './features/tiers/tier-management.component';
import { FindingsComponent } from './features/observability/findings.component';
import { MonitoringRulesComponent } from './features/settings/monitoring-rules.component';

import { adminGuard } from './core/guards/admin.guard';
import { AdminAuthInterceptor } from './core/interceptors/auth.interceptor';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forbidden', component: ForbiddenComponent },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [adminGuard],
    children: [
      { path: '', component: OverviewComponent, pathMatch: 'full' },
      { path: 'users', component: UserManagementComponent },
      { path: 'subscriptions', component: SubscriptionManagementComponent },
      { path: 'integrations', component: IntegrationControlComponent },
      { path: 'monitoring', component: MonitoringOverviewComponent },
      { path: 'tiers', component: TierManagementComponent },
      { path: 'observability/findings', component: FindingsComponent },
      { path: 'settings/monitoring',   component: MonitoringRulesComponent },
      { path: 'bug-reports', component: BugReportsComponent },
      { path: 'logs', component: SystemLogsComponent },
      { path: 'settings', component: AdminSettingsComponent },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    OverviewComponent,
    UserManagementComponent,
    SubscriptionManagementComponent,
    OrgContextSidebarComponent,
    IntegrationControlComponent,
    MonitoringOverviewComponent,
    TierManagementComponent,
    FindingsComponent,
    MonitoringRulesComponent,
    SystemLogsComponent,
    BugReportsComponent,
    AdminSettingsComponent,
    LoginComponent,
    ForbiddenComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
    LucideAngularModule.pick({
      Activity,
      ArrowDown,
      CheckCircle,
      ArrowUp,
      CircleAlert,
      CircleCheck,
      CircleX,
      Cloud,
      Copy,
      CreditCard,
      Ellipsis,
      Eye,
      FileText,
      Github,
      Hash,
      Key,
      LayoutDashboard,
      Layers,
      List,
      ListTodo,
      MessageSquare,
      Loader,
      LogOut,
      RefreshCw,
      RotateCcw,
      ScrollText,
      Search,
      Settings,
      Settings2,
      Shield,
      Trash2,
      TriangleAlert,
      UserCheck,
      UserX,
      Users,
      X,
      Zap,
      Bug,
      ChevronDown,
      ChevronRight,
      Table2,
      GitMerge,
      Cpu,
      ScanSearch,
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AdminAuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
